var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-3" },
    [
      _c(
        "custom-callout",
        {
          staticClass: "mb-0",
          attrs: {
            "border-color": _vm.getStatusColor,
            "has-toggle": _vm.isRefund,
            opened: _vm.isOpen
          },
          on: { "click:open": _vm.onOpenClose },
          scopedSlots: _vm._u([
            {
              key: "edition",
              fn: function() {
                return [
                  _c("div", { staticClass: "additional-container" }, [
                    _c("div", { staticClass: "p2 mt-1" }, [
                      _c("div", { staticClass: "bg-gray p-2" }, [
                        _c(
                          "div",
                          { staticClass: "bg-white p-3 rounded pl-c-xl" },
                          [
                            _c(
                              "custom-tab",
                              {
                                attrs: {
                                  "content-class": "mt-3",
                                  "nav-class": "nav-vue-underline",
                                  "no-nav-style": true
                                }
                              },
                              [
                                _c(
                                  "custom-tab-item",
                                  {
                                    staticClass: "mt-2 regular",
                                    attrs: { title: "Información Adicional" }
                                  },
                                  [
                                    _c("icon-view", {
                                      staticClass: "ml-3",
                                      attrs: {
                                        icon: "fas fa-info-circle",
                                        "icon-background": "#FFF",
                                        "icon-color": "#ff7058",
                                        "icon-size": "16px",
                                        title: "Información Adicional"
                                      }
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "row pl-5 pr-4 pb-4" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-12 col-md-2 pt-4"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "ml-2 regular text-gray"
                                              },
                                              [_vm._v(" Número de Consulta: ")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "ml-2 regular color-black"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("empty")(
                                                        _vm.data
                                                          .tapRequestNumber
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-12 col-md-2 pt-4"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "font-14 text-gray"
                                              },
                                              [_vm._v(" Centro: ")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "regular color-black"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("empty")(
                                                        _vm.data.centerName
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-12 col-md-2 pt-4"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "font-14 text-gray"
                                              },
                                              [_vm._v(" Municipio: ")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "regular color-black"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("empty")(
                                                        _vm.data
                                                          .municipalityName
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-12 col-md-2 pt-4"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "font-14 text-gray"
                                              },
                                              [_vm._v(" Escuela: ")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "regular color-black"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("empty")(
                                                        _vm.data.schoolName
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "custom-tab-item",
                                  {
                                    staticClass: "mt-2 regular",
                                    attrs: { title: "Información de Contacto" },
                                    on: { click: _vm.getContactInformation }
                                  },
                                  [
                                    _c("icon-view", {
                                      staticClass: "ml-3",
                                      attrs: {
                                        icon: "fas fa-info-circle",
                                        "icon-background": "#FFF",
                                        "icon-color": "#ff7058",
                                        "icon-size": "16px",
                                        title: "Información de Contacto"
                                      }
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "row pl-5 pr-4 pb-4" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-12 col-md-2 pt-4"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "ml-2 regular text-gray"
                                              },
                                              [_vm._v(" Nombre: ")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "ml-2 regular color-black"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("empty")(
                                                        _vm.contactInformation
                                                          .contactName
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-12 col-md-2 pt-4"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "font-14 text-gray"
                                              },
                                              [_vm._v(" Parentesco: ")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "regular color-black"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("empty")(
                                                        _vm.contactInformation
                                                          .contactRelationName
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-12 col-md-2 pt-4"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "font-14 text-gray"
                                              },
                                              [_vm._v(" Correo electrónico: ")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "regular color-black"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("empty")(
                                                        _vm.contactInformation
                                                          .contactEmail
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-12 col-md-2 pt-4"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "font-14 text-gray"
                                              },
                                              [_vm._v(" Teléfono: ")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "regular color-black"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("phone")(
                                                        _vm.contactInformation
                                                          .contactTelephone
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "row mx-auto p-0 py-2" }, [
            _c(
              "div",
              { staticClass: "col-2 text-center border-right p-0 pr-3" },
              [
                _c(
                  "div",
                  {
                    class: `badge badge-pill font-16 py-2 mt-2 w-70 mx-auto color-black bg-${_vm.getStatusColor}`
                  },
                  [_vm._v(" " + _vm._s(_vm.data.requestStatusName) + " ")]
                ),
                _c("div", { staticClass: "mt-2 pt-1" }, [
                  _c("div", { staticClass: "color-black font-weight-bold" }, [
                    _vm._v(" " + _vm._s(_vm.data.requestNumber) + " ")
                  ])
                ]),
                _vm.isOneTimePayment
                  ? _c("div", { staticClass: "mt-2" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "badge badge-pill font-12 mt-1 py-1 px-2 one-time-badge"
                        },
                        [_vm._v(" One Time Payment ")]
                      )
                    ])
                  : _vm._e()
              ]
            ),
            _c("div", { staticClass: "col-8 p-0" }, [
              _c("div", { staticClass: "row mx-auto p-0 py-3" }, [
                _c("div", { staticClass: "col-12 col-md-4 pl-4" }, [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v(" Nombre del Estudiante: ")]
                    ),
                    _c("span", { staticClass: "font-16 color-black" }, [
                      _vm._v(" " + _vm._s(_vm.data.studentNameSie) + " ")
                    ])
                  ])
                ]),
                _c("div", { staticClass: "col-12 col-md-2" }, [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v(" Mes: ")]
                    ),
                    _c("span", { staticClass: "font-16 color-black" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.selectedPeriods(_vm.data.periods)) +
                          " "
                      )
                    ])
                  ])
                ]),
                _c("div", { staticClass: "col-12 col-md" }, [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v(" Determinación: ")]
                    ),
                    _c("span", { staticClass: "font-16 color-black" }, [
                      _vm._v(" " + _vm._s(_vm.data.requestTypeName) + " ")
                    ])
                  ])
                ]),
                _c("div", { staticClass: "col-12 col-md" }, [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v("Monto:")]
                    ),
                    _vm.data.amountToRefund
                      ? _c("b", { staticClass: "font-16 color-green" }, [
                          _vm._v(
                            " $" +
                              _vm._s(
                                _vm._f("currency")(_vm.data.amountToRefund)
                              ) +
                              " "
                          )
                        ])
                      : _c("b", { staticClass: "font-16 color-green" }, [
                          _vm._v(" $0.00 ")
                        ])
                  ])
                ]),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm.data.submittedDate
                      ? _c("div", { staticClass: "col-12 col-md-4 pl-4" }, [
                          _c("div", { staticClass: "pt-3" }, [
                            _c(
                              "span",
                              { staticClass: "color-gray-6 d-block font-14" },
                              [_vm._v(" Fecha de Sometido: ")]
                            ),
                            _c("div", { staticClass: "font-16 color-black" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("empty")(
                                      _vm._f("date")(_vm.data.submittedDate)
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "col-12 col-md",
                        class: { "pl-4": !_vm.data.submittedDate }
                      },
                      [
                        _c("div", { staticClass: "pt-3" }, [
                          _c(
                            "span",
                            { staticClass: "color-gray-6 d-block font-14" },
                            [_vm._v(" Institución: ")]
                          ),
                          _c("span", { staticClass: "font-16 color-black" }, [
                            _vm._v(" " + _vm._s(_vm.data.schoolName) + " ")
                          ])
                        ])
                      ]
                    ),
                    _vm.data.selectedServices.length > 0
                      ? _c("div", { staticClass: "col-12 col-md" }, [
                          _c("div", { staticClass: "pt-3" }, [
                            _c(
                              "span",
                              { staticClass: "color-gray-6 d-block font-14" },
                              [_vm._v(" Servicios: ")]
                            ),
                            _c("span", { staticClass: "font-16 color-black" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.data.selectedServices.join(",")) +
                                  " "
                              )
                            ])
                          ])
                        ])
                      : _vm._e()
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "col-2" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 pt-1" },
                  [
                    _c(
                      "action-button",
                      {
                        attrs: {
                          id: "on-detail-btn-identifier",
                          i: "fas fa-file-import",
                          variant: "outline-success"
                        },
                        on: { click: _vm.onDetailHandler }
                      },
                      [_vm._v(" Entrar ")]
                    )
                  ],
                  1
                ),
                _vm.canCreateAdditionalPayment
                  ? _c(
                      "div",
                      { staticClass: "col-12 pt-1" },
                      [
                        _c(
                          "action-button",
                          {
                            attrs: {
                              id: "on-detail-btn-identifier",
                              i: "fas fa-file-import",
                              variant: "outline-success"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onAdditionalPaymentClick(
                                  _vm.data.requestId
                                )
                              }
                            }
                          },
                          [_vm._v(" Pago Adicional ")]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.canViewAI
                  ? _c(
                      "div",
                      { staticClass: "col-12 pt-1" },
                      [
                        _c(
                          "action-button",
                          {
                            attrs: {
                              id: "on-detail-btn-identifier",
                              i: "fas fa-robot",
                              variant: "outline-success"
                            },
                            on: { click: _vm.onAIValidationHandler }
                          },
                          [_vm._v(" Validar ")]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]),
            _vm.checkable
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-md-1 py-0 pl-3 d-flex align-items-center justify-content-center row-check-section"
                  },
                  [
                    _c("check-box", {
                      class: [{ checked: _vm.data.checked }],
                      on: { input: _vm.onCheckHandler },
                      model: {
                        value: _vm.data.checked,
                        callback: function($$v) {
                          _vm.$set(_vm.data, "checked", $$v)
                        },
                        expression: "data.checked"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      ),
      _vm.signatureProcessText
        ? _c("div", { staticClass: "alert signature-alert px-2 pt-2 mb-0" }, [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("em", {
                staticClass: "fas fa-file-signature font-16 pl-2 ml-1"
              }),
              _c(
                "div",
                { staticClass: "font-16 font-weight-normal ml-3 alert-text" },
                [_vm._v(" " + _vm._s(_vm.signatureProcessText) + " ")]
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }